<template>
  <div class="navBar">
    <div class="navBarBox "
         v-if="navBarBoxShow"
         @mouseleave='leaveNavBar'>

      <p class="navBarBoxTwoL"
         @click="goHome">
        <img src="./img/companyName.png"
             alt="">
      </p>
      <div class="navBarBoxTwoR">
        <div class="navBarBoxTwoRList">
          <p class="title"
             @click="goHome"
             :class="{'active': newActiveIndex =='/'}">首 页</p>
          <p class="title"
             @mouseenter="enter"
             @mouseleave='out'>产品中心</p>
          <p class="title"
             @click="goSolve"
             :class="{'active': newActiveIndex ==  '/solve'}">解决方案</p>
          <p class="title"
             @click="goNewsCenter"
             :class="{'active': newActiveIndex == '/newsCenter'}">新闻中心</p>
          <p class="title"
             @click="goCase"
             :class="{'active': newActiveIndex == '/case'}">客户案例</p>
          <div class="title titleAbout"
               :class="{'active': newActiveIndex == '/aboutUs'}||{'active': newActiveIndex == '/contactUs'} "
               @mouseover="enterShowWe"
               @mouseout='outShowWe'>
            关于我们
            <div class="titleChild"
                 v-show="showWeChild||showWe"
                 @mouseenter="enterShowWeChild"
                 @mouseleave="outShowWeChild">
              <p @click="goContactUs">联系我们</p>
              <p @click="goAboutUs">关于我们</p>
            </div>

          </div>
          <!-- <p class="title" @click="goContactUs" :class="{'active': newActiveIndex == '/contactUs'}">联系我们</p> -->
        </div>
        <p class="navBarBoxTwoRPhone animation-phone">
          <span>
            <img src="./img/navPhone.png"
                 alt="">
          </span>
          400-991-9533
        </p>
      </div>
    </div>
    <!-- 不动时显示 -->
    <div class="navBarBoxTwo"
         v-if="!navBarBoxShow"
         @mouseenter='goNavBarBoxTwo'>
      <p class="navBarBoxTwoL">
        <img src="./img/navImg.png"
             alt="">
      </p>
      <div class="navBarBoxTwoR">
        <div class="navBarBoxTwoRList">
          <p>首页</p>
          <p>产品中心</p>
          <p>解决方案</p>
          <p>新闻中心</p>
          <p>客户案例</p>
          <p>关于我们</p>
        </div>
        <p class="navBarBoxTwoRPhone animation-phone">
          <span>
            <img src="./img/flexItem1.png"
                 alt="">
          </span>
          400-991-9533
        </p>
      </div>
    </div>
    <!-- 不动时显示结束 -->

    <!-- 固定浮动导航 -->
    <div class="flexBox">
      <!-- 电话沟通 -->
      <div class="flexBoxItem flexBoxItemPhone">
        <p class="flexBoxItemImg"><img src="./img/flexItem1.png"
               alt=""> </p>
        <p class="flexBoxItemTitle"
           v-show="showFlexBoxItem">电话沟通</p>
        <p class="flexBoxItemBorder"
           v-show="showFlexBoxItem"></p>
        <!-- <img class="flexBoxItemPhoneImg" src="./img/flex1.png" alt=""> -->
        <!-- 电话沟通 -->
        <div class="phone">
          <p class="phoneItem"><i> <img src="./img/phone1.png"
                   alt=""> </i> 400-991-9533</p>
          <!-- <p class="phoneItem"> <i> <img src="./img/phone2.png" alt=""> </i>工作时间</p>
          <p class="phoneItem">9:00/12:00 13:30/17:30</p> -->
        </div>
        <div class="phoneBtn"></div>
        <div class="phoneBtn2"></div>
      </div>

      <!-- 二维码 -->
      <div class="flexBoxItem flexBoxItemErWei">
        <p class="flexBoxItemImg"><img src="./img/flexItem2.png"
               alt=""> </p>
        <p class="flexBoxItemTitle"
           v-show="showFlexBoxItem">关注我们</p>
        <p class="flexBoxItemBorder"
           v-show="showFlexBoxItem"></p>
        <!-- <img src="./img/flex2.png" alt="" class="flexBoxItemErWeiImg"> -->
        <!-- 二维码 -->
        <div class="searchBCenimage">
          <p class="searchBCenTitle">关注官方公众号</p>
          <div class="searchImg">
            <img class="searchImgSelf"
                 :src="img"
                 alt="" />
          </div>
          <p class="searchBCenText">关注时空官方公众号</p>
          <p class="searchBCenText">了解更多</p>
        </div>
        <div class="searchBCenBtn"></div>
        <div class="searchBCenBtn2"></div>
      </div>
      <!-- 返回主页 -->
      <div class="flexBoxItem"
           @click="goHome">
        <p class="flexBoxItemImg"><img src="./img/flexItem4.png"
               alt=""> </p>
        <p class="flexBoxItemTitle"
           v-show="showFlexBoxItem">回到首页</p>
        <p class="flexBoxItemBorder"
           v-show="showFlexBoxItem"></p>
        <!-- <img src="./img/flex4.png" alt=""> -->
      </div>
      <!-- 获取方案 -->
      <div class="flexBoxItem"
           @click="goScheme">
        <p class="flexBoxItemImg"><img src="./img/flexItem3.png"
               alt=""> </p>
        <p class="flexBoxItemTitle"
           v-show="showFlexBoxItem">获取方案</p>
        <!-- <img src="./img/flex3.png" alt=""> -->
      </div>
    </div>
    <!-- 返回顶部 -->
    <div class="backTop"
         v-show="isShow"
         @click="backTop">
      <div class="backTopBox">
        <img class="backTopImg"
             src="./img/backTop.png"
             alt="">
        <span class="backTopText"
              v-show="showFlexBoxItem">返回顶部</span>
      </div>

    </div>
    <!-- 弹出层 -->
    <transition name="myNavPop">

      <div class="navPop"
           v-show="navPopShow|| navPopShow2"
           @mouseenter="enter2"
           @mouseleave='out2'>
        <!-- <a href="javascript:;" v-for="item in $store.state.productList" :key="item.ID" @click="toPath(item.ID)">{{item.Title}}</a>
       <a href="javascript:;" @click="toProductDown">产品下载</a> -->
        <div class="navPopContent">
          <div class="navPopLeft">
            <p class="navPopLeftTitle"
               index='/product'>产品推荐</p>
            <p class="navPopLeftBox">
              <a href="javascript:;"
                 class="navPopLeftItem"
                 v-for="item in navProduct"
                 :key="item.id"
                 @click="toProduct(item)">{{item.label}}</a>
              <!-- <a href="javascript:;" v-for="item in $store.state.productList" :key="item.ID" @click="toPath(item.ID)">{{item.Title}}</a> -->
            </p>
          </div>
          <div class="navPopRight">
            <p class="navPopLeftTitle">产品下载</p>
            <p class="navPopLeftBox">
              <a href="javascript:;"
                 @click="toProductDown">产品下载中心</a>
            </p>
          </div>
          <div class="navPopRight">
            <p class="navPopLeftTitle">全部产品</p>
            <p class="navPopLeftBox">
              <!-- <a href="javascript:;" @click="toProductList">全部产品列表</a> -->
            </p>
          </div>
        </div>
        <!-- 导航中地址栏 -->
        <div class="navDz">
          <div class="navDzBox">
            <p>
              <span class="navDzImg"><img src="./img/navB1.png"
                     alt=""></span> <span>官方服务热线：400-991-9533</span>
            </p>
            <p>
              <span class="navDzImg"><img src="./img/navB2.png"
                     alt=""></span> <span>公司邮箱：zsh424@126.com</span>
            </p>
            <p>
              <span class="navDzImg"><img src="./img/navB3.png"
                     alt=""></span> <span>地址：郑州市经济开发区航海东路与二十三大街中科智谷创新园12号楼7层</span>
            </p>
          </div>
          <span class="navDzClose"
                @click="out2"><img src="./img/navB4.png"
                 alt=""></span>
        </div>
      </div>
    </transition>
    <!-- 留言板 -->
    <MessageBoard class="MessageBoard" />
    <!-- 获取方案 -->
    <GetScheme class="GetScheme"
               :showScheme='showScheme'
               @SetShowScheme="getScheme" />
  </div>
</template>

<script>
import MessageBoard from './cpmponents/Pc/messageBoard.vue'
import GetScheme from './cpmponents/Pc/getScheme.vue'
export default {
  name: 'navBar',
  components: { MessageBoard, GetScheme },
  data () {
    return {
      navList: [
        { label: '首页', path: '/', name: 'firstPage', id: '1' },
        { label: '关于时空', path: '/aboutUs', name: 'aboutUs', id: '2' },
        // { label: '产品中心', path: '/productMain', name: 'productCenter', id: '3' },
        { label: '解决方案', path: '/solve', name: 'firstPage', id: '4' },
        { label: '新闻中心', path: '/newsCenter', name: 'PressCenter', id: '5' },
        { label: '联系我们', path: '/contactUs', name: 'contactUs', id: '6' }
      ],
      activeIndex: '/', // 默认菜单index
      navPopShow: false, // 2级弹出层
      navPopShow2: false, // 2级弹出层
      showScheme: false, // 控制获取方案显示隐藏
      navProduct: [
        { label: '仓储精细化管理系统', path: '/wmsView', id: 101 },
        { label: 'TMS运输管理系统', path: '/tmsView', id: 102 },
        { label: '时空资源计划管理系统', path: '/repView', id: 103 },
        // { label: 'ERP管理系统', path: '/repView', id: 103 },
        { label: '时空业务中台', path: '/middleView', id: 104 },
        { label: 'OMS管理系统', path: '/omsView', id: 107 },
        { label: '电子商务平台', path: '/commerce', id: 105 },
        { label: '流通行业信息整体化架构', path: '/circulateView', id: 106 }
      ],
      isShow: false, // x显示返回顶部
      screenWidth: document.body.clientWidth, // 获取窗口的宽度
      showFlexBoxItem: true, // 页面放大缩小控制，浮动导航文字的显示
      navBarBoxShow: false, // 显示吸顶真正导航
      scrollTop: 0, // 滚动距离
      img: require('@/views/navbar/img/weixingongzhonghao.png'),
      showWe: false, // 控制关于我们显示隐藏
      showWeChild: false, // 控制关于我们显示隐藏
    }
  },
  created () {
    this.listenerFunction()
    this.inHome()
  },
  destroyed () {
    this.beforeDestroy()
  },
  mounted () {
    this.activeIndex = localStorage.getItem('index') ? localStorage.getItem('index') : '/'
    // console.log(this.$store.state.productList)
    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    // console.log(this.screenWidth,'this.screenWidth')
    if (this.screenWidth <= 1435) {
      this.showFlexBoxItem = false
    }
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
    window.addEventListener('scroll', this.handleScrollX) // 监听页面滚动
  },
  // 滚动重置
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScrollX)
  },
  computed: {
    newActiveIndex () {
      return this.$store.state.activeIndex
    }

  },
  watch: {
    activeIndex (newVal, oldVal) {
      // console.log(newVal, oldVal)
      // if (localStorage.getItem('index') !== '/') {
      //   console.log('llll')
      //   this.navBarBoxShow = true
      // }
    },
    newActiveIndex (newVal, oldVal) {
      // console.log(newVal, oldVal)
      if (localStorage.getItem('index') !== '/') {
        // console.log('llll')
        this.navBarBoxShow = true
      }
    },
    screenWidth: function (n, o) {
      if (n <= 1435) {
        // 判断右边导航标题显示
        // console.log('屏幕宽度小于1370了', this.screenWidth)
        this.showFlexBoxItem = false
        // document.documentElement.style.fontSize = 140 + 'px'
        // console.log(document.documentElement.style.fontSize)
      } else {
        // console.log('屏幕宽度大于1370', this.screenWidth)
        this.showFlexBoxItem = true
      }
      this.$store.commit('getScreenWidth', this.screenWidth)
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      // console.log(key, keyPath)
      this.activeIndex = key
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    // 点击跳转
    toPath (id) {
      // console.log(id, '123456')
      this.$router.push({ path: `/productItemShow/${id}` })
      this.navPopShow2 = false
    },
    toProductDown () {
      this.$router.push('/productMain')
      this.navPopShow2 = false
      this.activeIndex = '/product'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    toProductList () {
      this.$router.push('/productMainList')
      this.navPopShow2 = false
      this.activeIndex = '/product'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    // 鼠标进入
    enter () {
      // console.log('中心进')
      this.navPopShow = true
      // this.navPopShow2 = true
    },
    enter2 () {
      // console.log('qqqqqqq222')
      this.navPopShow2 = true
    },
    // 鼠标离开
    out () {
      // console.log('中心离开')
      setTimeout(() => {
        this.navPopShow = false
      }, 500)
      this.inHome()
    },
    out2 () {
      // console.log('qqqq2likai ')
      this.navPopShow2 = false
      if (this.scrollTop === 0) {
        setTimeout(() => {
          this.navBarBoxShow = false
          this.inHome()
        }, 500)
      }
    },
    // 点击跳转首页
    goHome () {
      this.$router.push('/')
      this.activeIndex = '/'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    // 跳转解决方案
    goSolve () {
      this.$router.push('/solve')
      this.activeIndex = '/solve'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    goScheme () {
      this.showScheme = !this.showScheme
      // this.$message({
      //   message: '模块还在更新中',
      //   type: 'warning'
      // })
    },
    getScheme (data) {
      this.showScheme = data
    },
    // 跳转新闻
    goNewsCenter () {
      this.$router.push('/newsCenter')
      this.activeIndex = '/newsCenter'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    // 跳转客户案例
    goCase () {
      this.$router.push('/case')
      this.activeIndex = '/case'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    // 跳转关于时空
    goAboutUs () {
      this.$router.push('/aboutUs')
      this.activeIndex = '/aboutUs'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    // 跳转练习我们
    goContactUs () {
      this.$router.push('/contactUs')
      this.activeIndex = '/contactUs'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    toProduct (item) {
      // if (item.label === '时空资源计划管理系统') { return }
      // console.log(item)
      this.$router.push(item.path)
      this.navPopShow2 = false
      this.activeIndex = '/product'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    // 监听页面
    listenerFunction (e) {
      document.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy () {
      document.removeEventListener('scroll', this.listenerFunction)
    },
    handleScroll () {
      // console.log(window.pageYOffset)
      if (window.pageYOffset > 250) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    // 返回顶部
    backTop () {
      const timer = setInterval(function () {
        const osTop = document.documentElement.scrollTop || document.body.scrollTop
        // console.log(osTop, 'osTop')
        const isPeed = Math.floor(-osTop / 5)
        // console.log(isPeed, 'this.isPeed')
        document.documentElement.scrollTop = document.body.scrollTop = osTop + isPeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 30)
      this.inHome()
    },
    // 获取页面滚动距离
    handleScrollX () {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // console.log(this.scrollTop, '滚动距离')
      if (this.scrollTop > 50 || this.navPopShow2) {
        this.navBarBoxShow = true
      } else {
        this.navBarBoxShow = false
      }
      if (this.$store.state.activeIndex !== '/') {
        this.navBarBoxShow = true
      }
      this.inHome()
    },
    // 鼠标经过顶部导航
    goNavBarBoxTwo () {
      this.navBarBoxShow = true
    },
    // 鼠标离开顶部导航
    leaveNavBar () {
      if (this.scrollTop === 0) {
        if (this.navPopShow || this.navPopShow2) {
          this.navBarBoxShow = true
        } else {
          this.navBarBoxShow = false
          // console.log(this.navBarBoxShow, 'if333')
        }
      }
      this.inHome()
    },
    // 判断是否在首页
    inHome () {
      if (this.$store.state.activeIndex !== '/') {
        this.navBarBoxShow = true
      }
    },
    // 经过关于我们
    enterShowWe () {
      this.showWe = true
    },
    outShowWe () {
      setTimeout(() => {
        this.showWe = false

      }, 200);
    },
    enterShowWeChild () {

      this.showWe = true
      this.showWeChild = true
    },
    outShowWeChild () {

      this.showWe = false
      this.showWeChild = false
    }

  }
}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun: 100/192;
p {
  margin: 0;
}
.navBar {
  position: relative;
  // background: #FFFFFF;
  border-bottom: 1px * $sun solid #e6e6e6;
  width: 100%;
  .el-menu.el-menu--horizontal {
    border: 0;
  }
  .animation-phone {
    animation: scaleDraw 5s ease-in-out infinite;
  }
  @keyframes scaleDraw {
    /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
    0% {
      transform: scale(1);
      /*开始为原始大小*/
    }
    25% {
      transform: scale(1.1);
      /*放大1.1倍*/
    }
    50% {
      transform: scale(1);
    }
    75% {
      transform: scale(1.1);
    }
  }
  // 样式导航
  .navBarBoxTwo {
    cursor: pointer;
    width: 100%;
    height: 100px * $sun;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 990;
    color: #fff;
    padding: 0 260px * $sun;
    // padding-top: 23px*$sun;
    box-sizing: border-box;
    .navBarBoxTwoL {
      float: left;
      width: 150px * $sun;
      height: 34px * $sun;
      margin-top: 33px * $sun;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .navBarBoxTwoR {
      margin-top: 38px * $sun;
      width: 1150px * $sun;
      font-size: 20px * $sun;
      float: right;
      .navBarBoxTwoRList {
        float: left;
        width: 960px * $sun;
        p {
          height: 62px * $sun;
          float: left;
          // font-style: normal;
          // font-style: normal;
          font-weight: 500;
          line-height: 100%;
          width: 80px * $sun;
          margin-right: 74px * $sun;
          position: relative;
          text-align: center;
          white-space: nowrap;
        }
      }
      .navBarBoxTwoRPhone {
        float: right;
        font-size: 24px * $sun;
        height: 62px * $sun;
        position: relative;
        top: -2px * $sun;
        span {
          display: inline-block;
          width: 20px * $sun;
          height: 20px * $sun;
          margin-right: 8px * $sun;
          position: absolute;
          top: 0;
          left: -30px * $sun;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  // 实际导航
  .navBarBox {
    cursor: pointer;
    width: 100%;
    height: 100px * $sun;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 990;
    color: #000;
    padding: 0 260px * $sun;
    // padding-top: 23px*$sun;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0 4px * $sun 8px * $sun 0 rgba(0, 0, 0, 0.2);
    .navBarBoxTwoL {
      float: left;
      width: 150px * $sun;
      height: 34px * $sun;
      margin-top: 33px * $sun;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .navBarBoxTwoR {
      margin-top: 38px * $sun;
      width: 1150px * $sun;
      font-size: 20px * $sun;
      float: right;
      .navBarBoxTwoRList {
        float: left;
        width: 960px * $sun;
        .active {
          color: #2380e1;
        }
        .active:before,
        .active:after {
          content: "";
          width: 0;
          height: 2px * $sun;
          background-color: #2380e1;
          position: absolute;
          top: 96%;
          left: 50%;
          transition: all 0.8s;
        }
        .active:before {
          width: 50%;
          left: 25%;
        }

        .active:after {
          width: 25%;
          right: 0;
        }
        .titleAbout {
          // padding-bottom: 100px;
        }
        .title {
          height: 42px * $sun;
          float: left;
          // font-style: normal;
          // font-style: normal;
          font-weight: 500;
          line-height: 100%;
          width: 80px * $sun;
          margin-right: 74px * $sun;
          position: relative;
          text-align: center;
          white-space: nowrap;
          // 联系我们导航
          .titleChild {
            // display: none;
            width: 100px * $sun;
            height: 100px * $sun;
            position: absolute;
            bottom: -120px * $sun;
            line-height: 50px * $sun;
            z-index: 10;
            background: #fff;
            box-shadow: 0 4px * $sun 8px * $sun 0 rgba(0, 0, 0, 0.2);
            color: #000;
          }
          .titleChild > p:hover {
            color: #2380e1;
          }
        }
        // 加动画
        .title:before,
        .title:after {
          content: "";
          width: 0;
          height: 2px * $sun;
          background-color: #2380e1;
          position: absolute;
          top: 96%;
          left: 50%;
          transition: all 0.8s;
        }

        .title:hover {
          color: #2380e1;
        }
        .title:hover:before {
          width: 50%;
          left: 25%;
        }

        .title:hover:after {
          width: 25%;
          right: 0;
        }

        // 动画结束
      }
      .navBarBoxTwoRPhone {
        float: right;
        font-size: 24px * $sun;
        height: 62px * $sun;
        position: relative;
        top: -2px * $sun;
        color: #2380e1;
        span {
          display: inline-block;
          width: 20px * $sun;
          height: 20px * $sun;
          margin-right: 8px * $sun;
          position: absolute;
          top: 0;
          left: -30px * $sun;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  font-size: 20px * $sun;
}
.image {
  width: 100%;
  height: 100%;
}
// 弹出层
.navPop {
  position: fixed;
  top: 100px * $sun;
  z-index: 999;
  background: #fff;
  box-shadow: 0 4px * $sun 8px * $sun 0 rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 730px * $sun;
  font-size: 20px * $sun;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // 导航地址
  .navDz {
    padding: 0 156px * $sun;
    background: #f7f7f7;
    height: 150px * $sun;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .navDzBox {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 16px * $sun;
      color: #595757;
      p {
        margin-right: 60px * $sun;
        display: flex;
        align-items: center;
        float: left;
        cursor: pointer;
        .navDzImg {
          width: 28px * $sun;
          height: 28px * $sun;
          margin-right: 10px * $sun;
          img {
            width: 28px * $sun;
            height: 28px * $sun;
          }
          span {
            font-weight: 500;
          }
        }
      }
    }
    .navDzClose {
      cursor: pointer;
      width: 26px * $sun;
      height: 26px * $sun;
      img {
        width: 26px * $sun;
        height: 26px * $sun;
      }
    }
  }
  // 导航盒子
  .navPopContent {
    width: 1920px * $sun;
    height: 600px * $sun;
    display: flex;
    // justify-content: space-between;
    margin: 50px * $sun 156px * $sun;
    margin-bottom: 0;
  }
  // 导航弹出左边
  .navPopLeft {
    width: 772px * $sun;
    height: 600px * $sun;
    margin-right: 40px * $sun;
    float: left;
    .navPopLeftTitle {
      font-size: 23px * $sun;
      padding-bottom: 20px * $sun;
      border-bottom: 1px * $sun solid #e6e6e6;
      font-weight: 500;
    }
    .navPopLeftBox {
      display: flex;
      // flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
      flex-direction: column;
      height: 370px * $sun;
      .navPopLeftItem {
        width: 240px * $sun;
        display: block;
        font-weight: 500;
      }
      a {
        font-weight: 500;
      }
    }
  }
  // 导航弹出右边
  .navPopRight {
    width: 282px * $sun;
    float: left;
    margin-right: 40px * $sun;
    .navPopLeftTitle {
      font-size: 23px * $sun;
      padding-bottom: 20px * $sun;
      border-bottom: 1px * $sun solid #e6e6e6;
      font-weight: 500;
    }
    .navPopLeftBox {
      float: left;
      display: flex;
      // flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
    a {
      width: 100%;
      font-weight: 500;
    }
  }
  a {
    width: 25%;
    font-weight: 500;
    // display: block;
    margin-top: 25px * $sun;
    margin-bottom: 25px * $sun;
    color: #333;
    // text-align:center;
  }
  a:hover {
    color: #007aff;
    text-decoration: underline;
  }
}
// 最后一行靠左
// .navPop::after {
//     content: '';
//     flex: auto;    /* 或者flex: 1 */
// }
// 过度样式
/* 给过渡的name加样式 */

.myNavPop-enter-active {
  transition: all 0.2s;
}

.myNavPop-leave-active,
.myNavPop-enter {
  height: 0px * $sun !important;
  opacity: 0 !important;
  // display: none;
}

.myNavPop-leave,
.myNavPop-enter-active {
  height: 600px * $sun;
  opacity: 1;
  // display: block;
}
// 弹出层结束
// 固定浮动导航
.flexBox {
  position: fixed;
  right: 0px * $sun;
  // top: 400px*$sun;
  bottom: 80px * $sun;
  z-index: 999;
  width: 68px * $sun;
  height: 280px * $sun;
  background: #2380e1;
  border-radius: 6px * $sun;
  .flexBoxItem {
    overflow: hidden;
    width: 100%;
    height: 70px * $sun;
    cursor: pointer;
    transition: all 0.2s;
    opacity: 0.8;
    box-sizing: border-box;
    padding-top: 12px * $sun;
    // margin-left: 9px*$sun;
    // margin-right: 9px*$sun;
    .flexBoxItemImg {
      width: 22px * $sun;
      height: 22px * $sun;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .flexBoxItemTitle {
      width: 100%;
      min-width: 52px * $sun;
      overflow: hidden;
      color: #ffffff;
      text-align: center;
      font-size: 12px * $sun;
      height: 16px * $sun;
      margin-bottom: 12px * $sun;
      margin-top: 6px * $sun;
    }
    .flexBoxItemBorder {
      width: 32px * $sun;
      border: 1px * $sun solid #fff;
      margin: 0 auto;
    }
  }
  // img{
  //   width: 100%;
  // }
}

// 电话弹出
.phone {
  // opacity: 0;
  display: none !important;
  width: 240px * $sun;
  height: 58px * $sun;
  background-color: #fff;
  // position: relative;
  position: fixed;
  right: 100px * $sun;
  // top: 380px*$sun;
  bottom: 300px * $sun;
  box-shadow: 0 4px * $sun 8px * $sun 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // padding: 26px*$sun;
  box-sizing: border-box;
  align-items: center;
  overflow: hidden;
  border-radius: 8px * $sun;
  .phoneItem {
    height: 100%;
    font-size: 18px * $sun;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    // margin-top: 10px*$sun;
    i {
      width: 18px * $sun;
      height: 18px * $sun;
      img {
        width: 18px * $sun;
        height: 18px * $sun;
      }
    }
  }
}
.phoneBtn {
  width: 0;
  height: 0;
  border-width: 11px * $sun;
  border-style: solid;
  border-color: transparent transparent transparent rgba(66, 65, 65, 0.2);
  position: fixed;
  right: 81px * $sun;
  bottom: 320px * $sun;
  display: none;
  // display: none;
  // box-shadow: 0 4px*$sun 8px*$sun 0 rgba(0, 0, 0, 0.2)
  // top: 35px*$sun;
  // display: block;
}
.phoneBtn2 {
  width: 0;
  height: 0;
  border-width: 10px * $sun;
  border-style: solid;
  border-color: transparent transparent transparent #fff;
  position: fixed;
  right: 83px * $sun;
  bottom: 321px * $sun;
  display: none;
}
.flexBoxItem:hover {
  opacity: 1;
}
.flexBoxItem:hover .phone {
  display: block !important;
  // opacity: 1;
}
.flexBoxItem:hover .phoneBtn {
  display: block !important;
  // opacity: 1;
}
.flexBoxItem:hover .phoneBtn2 {
  display: block !important;
  // opacity: 1;
}
// 二维码
.searchBCenimage {
  // opacity: 0;
  display: none !important;
  width: 160px * $sun;
  height: 235px * $sun;
  background-color: #fff;
  position: fixed;
  right: 100px * $sun;
  // top: 680px*$sun;
  bottom: 80px * $sun;
  box-shadow: 0 4px * $sun 8px * $sun 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // padding: 26px*$sun;
  box-sizing: border-box;
  align-items: center;
  overflow: hidden;
  border-radius: 8px * $sun;
  padding: 10px * $sun 0;
  .searchBCenTitle {
    color: #2380e1;
    font-weight: 500;
    font-size: 14px * $sun;
    margin-top: 6px * $sun;

    margin-bottom: 6px * $sun;
  }
  .searchBCenText {
    font-size: 12px * $sun;
    margin-bottom: 6px * $sun;
  }
  p {
    text-align: center;
    font-size: 12px * $sun;
  }
  .searchImg {
    width: 145px * $sun;
    height: 145px * $sun;
    margin: 0 auto !important;
    // width: 145px*$sun;
    // height: 145px*$sun;
    .searchImgSelf {
      width: 145px * $sun;
      height: 145px * $sun;
    }
  }
  p {
    font-size: 16px * $sun;
  }
}
.searchBCenBtn {
  width: 0;
  height: 0;
  border-width: 11px * $sun;
  border-style: solid;
  border-color: transparent transparent transparent rgba(66, 65, 65, 0.2);
  position: fixed;
  right: 81px * $sun;
  bottom: 269px * $sun;
  display: none;
  // display: none;
  // box-shadow: 0 4px*$sun 8px*$sun 0 rgba(0, 0, 0, 0.2)
  // top: 35px*$sun;
  // display: block;
}
.searchBCenBtn2 {
  width: 0;
  height: 0;
  border-width: 10px * $sun;
  border-style: solid;
  border-color: transparent transparent transparent #fff;
  position: fixed;
  right: 83px * $sun;
  bottom: 270px * $sun;
  display: none;
}
.flexBoxItemErWei:hover .searchBCenimage {
  // opacity: 1;
  display: block !important;
}
.flexBoxItemErWei:hover .searchBCenBtn {
  display: block !important;
  // opacity: 1;
}
.flexBoxItemErWei:hover .searchBCenBtn2 {
  display: block !important;
  // opacity: 1;
}
// 返回顶部
.backTop {
  position: fixed;
  right: 0px * $sun;
  bottom: 0px * $sun;
  z-index: 999;
  width: 68px * $sun;
  height: 68px * $sun;
  background: #2380e1;
  border-radius: 6px * $sun;
  color: #ffffff;
  cursor: pointer;

  font-size: 12px * $sun;
  .backTopBox {
    width: 100%;
    height: 100%;
    opacity: 0.8;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .backTopImg {
    width: 22px * $sun;
    height: 22px * $sun;
    margin-bottom: 10px * $sun;
  }
}
.backTopBox:hover {
  opacity: 1;
}
// 留言版
.MessageBoard {
  position: fixed;
  left: 20px * $sun;
  bottom: 20px * $sun;
  z-index: 990;
  background: #ffffff;
  border-radius: 8px * $sun;
}
// 获取方案
.GetScheme {
  position: fixed;
  z-index: 995;
}
</style>
